import React from "react";
import { Helmet } from "react-helmet-async";

export const SITE_NAME = "Tech Venture LLC";
export const SITE_URL = "https://techventurellc.com";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;
export const DEFAULT_DESCRIPTION =
  "Free interview questions and answers, tutorials, quizzes, and system design guides for Java, Python, React, AWS, Kafka, SQL, and more.";

/**
 * Reusable per-page SEO tag setter, backed by react-helmet-async.
 * Every route should render this once with a unique title/description.
 */
export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  path = "",
  canonicalPath,
  image = DEFAULT_OG_IMAGE,
  noindex = false,
  type = "website",
}) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const resolvedPath = canonicalPath || path;
  const canonical = `${SITE_URL}${resolvedPath.startsWith("/") ? resolvedPath : `/${resolvedPath}`}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
